import React from 'react';
import { Container } from './styled';
import routes from '../../../../components/Routes/routingMap';
import Link from '@/presentation/reusables/Link';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

interface LiskProps {
  tabIndexButton: number;
}

const LinkProcedureAmount = ({ tabIndexButton = 0 }: LiskProps) => (
  <Container data-testid="cmp-link-procedure-amount">
    <p>
      Activa aquí el {''}
      <Link
        onClick={() =>
          GoogleAnalytics.writeLog(
            'portal-procedure-clickLoadOtherProcedures',
            'procedure'
          )
        }
        linkType="internal"
        url={routes.student.procedures.charge}
        linkName="cargo de otros trámites."
        tabIndex={tabIndexButton}
      />
    </p>
  </Container>
);

export default LinkProcedureAmount;
